import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

const StyledFixedFooterButtons = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  padding: ${themeGet('scale.scaleUp08')} ${themeGet('scale.scaleUp03')}
    ${themeGet('scale.scaleUp03')};
  background-image: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    ${themeGet('color.colorWhite')}
  );
  z-index: ${themeGet('zIndex.zIndex01')};

  @media (min-width: ${themeGet('breakpoint.breakpointTablet')}) {
    display: none;
  }

  @media (max-width: ${themeGet('breakpoint.breakpointTablet')}) {
    .btn-list {
      flex-direction: row;
    }

    .btn-list .btn {
      min-width: auto;
      margin: ${themeGet('scale.scaleDown02')};
    }

    .btn-list .btn:first-of-type {
      margin-left: 0;
    }

    .btn-list .btn:last-of-type {
      margin-right: 0;
    }
  }
`;

export default StyledFixedFooterButtons;
